var TEXT_MESSAGE_BODY_CLASSNAME = 'sendbird-text-message-item-body';
export { TEXT_MESSAGE_BODY_CLASSNAME as T };